import { SelectLanguageLayer } from './SelectLanguageLayer';
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Utils";
import { GameConstants } from "../../GameConstants";
import { BootScene } from "../BootScene";
import { AudioManager } from "../../AudioManager";

export class SplashScene extends Phaser.Scene {

    public static currentInstance: SplashScene;

    private audioOnButton: Button;
    private audioOffButton: Button;

    private playButton: Button;

    constructor() {

        super("SplashScene");
    }

    public create(): void {

        SplashScene.currentInstance = this;

        GameManager.setCurrentScene(this);

        const bg = new Phaser.GameObjects.Image(this, GameConstants.GAME_WIDTH * .5, GameConstants.GAME_HEIGHT * .5, "texture_atlas_1", "bg_splash");
        bg.scaleY = GameVars.scaleY;
        bg.setOrigin(.5);
        this.add.existing(bg);

        const title = new Phaser.GameObjects.Image(this, GameConstants.GAME_WIDTH * .5, GameConstants.GAME_HEIGHT * .2, "texture_atlas_1", "title");
        title.scaleY = GameVars.scaleY;
        title.setOrigin(.5);
        this.add.existing(title);

        const timeNinjaBlurred = new Phaser.GameObjects.Image(this, 75, GameConstants.GAME_HEIGHT * .55, "texture_atlas_1", "splash_char_blurred");
        timeNinjaBlurred.setScale(0);
        timeNinjaBlurred.setOrigin(.15, .5);
        this.add.existing(timeNinjaBlurred);

        this.tweens.add({
            targets: timeNinjaBlurred,
            x: 100,
            alpha: 0,
            scaleX: 1,
            scaleY: GameVars.scaleY, 
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 1500,
            delay: 500
        });

        const timeNinja = new Phaser.GameObjects.Image(this, 75, GameConstants.GAME_HEIGHT * .55, "texture_atlas_1", "splash_char");
        timeNinja.setScale(0, 0);
        timeNinja.setOrigin(.15, .5);
        timeNinja.alpha = 0;
        this.add.existing(timeNinja);

        this.tweens.add({
            targets: timeNinja,
            x: 100,
            alpha: 1,
            scaleX: 1,
            scaleY: GameVars.scaleY, 
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 2000,
            delay: 500
        });

        this.tweens.add({
            targets: timeNinja,
            scaleX: 1.035,
            scaleY: 1.035 * GameVars.scaleY, 
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 2150,
            delay: 2500,
            repeat: -1,
            yoyo: true
        });

        this.audioOnButton = new Button(this, GameConstants.GAME_WIDTH - 30, 30 * GameVars.scaleY, "texture_atlas_1", "btn_sound_on_off", "btn_sound_on_on");
        this.audioOnButton.onUp(this.onClickAudioButton, this);
        this.audioOnButton.scaleY = GameVars.scaleY;
        this.add.existing(this.audioOnButton);

        this.audioOffButton = new Button(this, GameConstants.GAME_WIDTH - 30, 30 * GameVars.scaleY, "texture_atlas_1", "btn_sound_off_off", "btn_sound_off_on");
        this.audioOffButton.onUp(this.onClickAudioButton, this);
        this.audioOffButton.scaleY = GameVars.scaleY;
        this.add.existing(this.audioOffButton);

        if (GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }

        this.playButton = new Button(this, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT * .9, "texture_atlas_2_" + GameVars.gameData.language, "btn_play_off", "btn_play_on");
        this.playButton.setInflationTween(1.1, 1, GameVars.scaleY);
        this.playButton.onUp(this.onClickPlay, this);
        this.add.existing(this.playButton);

        const selectLanguageLayer = new SelectLanguageLayer(this);
        this.add.existing(selectLanguageLayer);

        this.cameras.main.fadeIn(250, 19, 21, 54);

        this.cameras.main.zoom = .965;
        this.cameras.main.zoomTo(1, 250);
    }

    public languageChanged(): void {

        this.playButton.destroy();

        this.playButton = new Button(this, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT * .9, "texture_atlas_2_" + GameVars.gameData.language, "btn_play_off", "btn_play_on");
        this.playButton.setInflationTween(1.1, 1, GameVars.scaleY);
        this.playButton.onUp(this.onClickPlay, this);
        this.add.existing(this.playButton);
    }

    public update(time: number, delta: number): void {

        super.update(time, delta);

        BootScene.staticUpdate();
    }

    private onClickAudioButton(): void {
        
        AudioManager.toggleAudioState();

        if (GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }
    }

    private onClickPlay(): void {

        this.cameras.main.fadeOut(150, 19, 21, 54);

        this.cameras.main.once("camerafadeoutcomplete", function (camera) {
            GameManager.enterMazeScene();
        });

        AudioManager.playSound("click");
    }
}
